<template>
    <div class="navigator" :class="{has_links: links.length > 0}">
      <template v-if="links.length > 0">
        <div>
          <span v-for="(link, index) in links" :key="index" class="navigator_item" :class="{w100: links.length === 1}">
            <router-link v-if="link.route" :to="link.route">
              <span class="icon_arrow"></span> {{link.title}}
            </router-link>
            <span v-else>{{link.title}}</span>
          </span>
        </div>
        <span class="btn_fineplay" v-if="fineplay && links.length > 1 && canApplyFinePlay()" @click="handleToggleFineplayScreenChat">
          <img src="@/assets/icon-cup-white.png" alt="">
        </span>
      </template>
      <template v-else>
        <span class="menu_button" @click="toggleMenu">
          <span v-if="numberUnReadFineplayApprove" class="badge" v-show="!showMenu">{{numberUnReadFineplayApprove}}</span>
        </span>
        <span>
          {{title}}
        </span>

        <div class="menus" v-show="showMenu">
          <div class="item sns" @click="goTo('home')">
            <span class="icon"></span> チャット
          </div>
          <div class="item share" @click="goTo('shares')">
            <span class="icon"></span> シェア
          </div>
          <div class="item fine_play" @click="goTo('finePlays')">
            <span class="icon"></span> ファインプレー
          </div>
          <div v-if="canApproveFinePlay" class="item fine_play_approve" @click="goTo('finePlayApproves')">
            <span class="icon"></span> 未承認
            <span v-if="numberUnReadFineplayApprove" class="badge_item">{{numberUnReadFineplayApprove}}</span>
          </div>
          <div v-if="canShowSurvey" class="item survey" @click="goTo('surveys.index')">
            <span class="icon"></span> アンケート
            <span v-if="numberSurveyNotComplete" class="badge_item">{{numberSurveyNotComplete}}</span>
          </div>
          <div class="item profile" @click="goTo('profile')">
            <span class="icon"></span> 設定
          </div>
          <div class="item logout" @click="logout">
            <span class="icon"></span> ログアウト
          </div>
        </div>
      </template>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {MS_AUTHORITY_SM, MR_AUTHORITY_SM, CAN_APPLY_FINEPLAY_AUTHORITIES, CAN_APPROVE_FINEPLAY, CAN_SHOW_SURVEY} from '@/config'

  export default {
    data () {
      return {
        showMenu: false,
        auth: this.$auth.watch.data,
        MS_AUTHORITY_SM,
        MR_AUTHORITY_SM,
        CAN_APPLY_FINEPLAY_AUTHORITIES
      }
    },
    computed: {
      ...mapGetters({
        links: 'navigator/links',
        title: 'navigator/title',
        fineplay: 'navigator/fineplay',
        numberUnReadFineplayApprove: 'masterData/numberUnReadFineplayApprove',
        numberSurveyNotComplete: 'masterData/numberSurveyNotComplete'
      }),
      canApproveFinePlay: function () {
        return CAN_APPROVE_FINEPLAY.indexOf(this.$auth.user().authority) !== -1
      },
      canShowSurvey () {
        return CAN_SHOW_SURVEY.indexOf(this.$auth.user().authority) !== -1
      }
    },
    watch: {
      '$route' () {
        this.showMenu = false
      }
    },
    methods: {
      ...mapActions({
        toogleFineplayScreenChat: 'navigator/toogleFineplayScreenChat'
      }),
      goTo (name) {
        this.showMenu = false
        this.$router.push({name})
      },
      toggleMenu () {
        this.showMenu = !this.showMenu
      },
      logout () {
        this.$loading.show()
        this.$auth.logout()
        window.location.reload()
      },
      handleToggleFineplayScreenChat () {
        this.toogleFineplayScreenChat()
      },
      canApplyFinePlay () {
        return CAN_APPLY_FINEPLAY_AUTHORITIES.indexOf(this.$auth.user().authority) !== -1
      }
    },
    mounted () {
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/navigator.vue